import crashlytics from '@react-native-firebase/crashlytics';

import {log} from '../logger.util';

export class CrashlyticsBackend {
  crashlytics: any;

  verbose: any;

  constructor({verbose}: any = {}) {
    this.verbose = verbose;
    this.crashlytics = crashlytics;
  }

  /**
   * @param {Error} error Expects an instance of Error; e.g. classes that extend Error will also be supported.
   */
  logError = (error: any) => {
    this.crashlytics().recordError(error);

    if (this.verbose) {
      log(`[Crashlytic] error: ${JSON.stringify(error)}`);
    }
  };

  /**
   * @example
   *
   * // create the wrapper
   * const myFunc = createErrorBoundaryAsync(
   *  (opt) => fetch(`/endpoint`, opt).then(res => res.json())
   * );
   *
   * // calling the function without error handling
   * // exceptions will be caught on the wrapper level
   * // which will log it to the Crashlytics
   * myFunc({ method: `get` });
   *
   * @param {Function} func the async function which needs to be wrapped
   * @returns {Function} function which wraps the argument and catches the exceptions of it
   */
  createErrorBoundaryAsync =
    (func: any) =>
    (...args: any[]) =>
      func?.(...args).catch(this.logError);
}
